export const BMAEmptyRelatedWork = {
  scheme: "",
  identifier: "",
  resource_type: "",
  relation_type: "references",
};